import Spinner from "../../others/Spinner/Spinner";
import StyledWrapper from "./style";

import { TButtonProps } from "./Button.type";

export default function Button({
  text,
  type,
  icon,
  onClick,
  className,
  disabled,
  children,
  title,
}: TButtonProps) {
  return (
    <StyledWrapper.Button
      type={type}
      onClick={onClick}
      className={className}
      disabled={disabled}
      title={title}
    >
      {children}
      {disabled ? <Spinner /> : text}
    </StyledWrapper.Button>
  );
}
